import includes from 'lodash/includes'
import type { BlogCategory } from '@ztechapps/common.contract'

/** A category may move to the top level (no new parent) or under any category that is neither itself nor one of its descendants. */
export function canMoveBlogCategory(
  category: Pick<BlogCategory, '_id'>,
  newParent: Pick<BlogCategory, '_id' | 'ancestors'> | null | undefined
): boolean {
  if (!newParent) {
    return true
  }

  return newParent._id !== category._id && !includes(newParent.ancestors, category._id)
}
